import yup from "../../../../utils/yup";

export const slackAliasSchema = yup.object({
  name: yup.string().required("Please enter a name."),
  image: yup.string().required("Please upload an image."),
});

export type SlackAliasForm = yup.InferType<typeof slackAliasSchema>;
